import { useEffect, useState } from "react";

const SLIDES = [
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/7264ff43-d829-4109-b314-a579bfe3bf40_WhatsApp-Image-2026-03-26-at-10.50.31-AM-2.jpeg?v=54a4abb57b10e1a3d1469a9f73a898e7",
    alt: "Blue Moon Beauty Salon & Spa - Luxury Services Muscat Oman",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/0dbba706-3ed9-4eb3-a474-bdbc6676323b_WhatsApp-Image-2026-03-26-at-10.50.25-AM.jpeg?v=eaeb12882a2ac55faf9e221e4b222ff9",
    alt: "Blue Moon Beauty Salon - Premium Beauty Treatments Al Koudh",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/b8f3ce77-eaca-4e7e-9310-7d3f3d1dd67a_WhatsApp-Image-2026-03-26-at-10.50.29-AM-4.jpeg?v=97143f9860a8aa37d1b3ef0d8d59bc03",
    alt: "Blue Moon Spa - Relaxing Wellness Experience Muscat",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/b97a2f48-2316-468e-a962-2992b03a85e6_WhatsApp-Image-2026-03-26-at-10.50.29-AM-3.jpeg?v=0d5374a04a7c7185ddd30802334d7a80",
    alt: "Blue Moon Beauty Salon - Professional Hair & Beauty Services",
  },
  {
    src: "https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/2d72a372-7f6f-41da-a480-501ec443d5e7_WhatsApp-Image-2026-03-26-at-10.50.27-AM-1.jpeg?v=2f0e79243e27dbc091f4f37db03fff9f",
    alt: "Blue Moon Beauty Salon Muscat - Expert Beauty & Spa Treatments",
  },
];

const KEN_BURNS_CLASSES = [
  "animate-kb-1",
  "animate-kb-2",
  "animate-kb-3",
  "animate-kb-4",
  "animate-kb-5",
];

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState<number | null>(null);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrev(current);
      setTransitioning(true);
      setCurrent((c) => (c + 1) % SLIDES.length);
      setTimeout(() => {
        setPrev(null);
        setTransitioning(false);
      }, 1200);
    }, 5000);
    return () => clearInterval(interval);
  }, [current]);

  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      {/* Slideshow Background */}
      <div className="absolute inset-0">
        {SLIDES.map((slide, i) => {
          const isActive = i === current;
          const isPrev = i === prev;
          return (
            <div
              key={i}
              className="absolute inset-0 transition-opacity duration-[1200ms] ease-in-out"
              style={{
                opacity: isActive ? 1 : isPrev && transitioning ? 0 : 0,
                zIndex: isActive ? 2 : isPrev ? 1 : 0,
              }}
            >
              <img
                src={slide.src}
                alt={slide.alt}
                className={`w-full h-full object-cover object-top ${isActive ? KEN_BURNS_CLASSES[i % KEN_BURNS_CLASSES.length] : ""}`}
                loading={i === 0 ? "eager" : "lazy"}
              />
            </div>
          );
        })}

        {/* Overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65" style={{ zIndex: 3 }}></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a2744]/40 to-transparent" style={{ zIndex: 3 }}></div>
      </div>

      {/* Content */}
      <div
        className={`relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 sm:px-6 transition-all duration-1000 ${
          loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
        style={{ zIndex: 4 }}
      >
        {/* Moon icon badge */}
        <div className="w-12 h-12 flex items-center justify-center mb-4 border border-[#c6a864]/60">
          <i className="ri-moon-line text-[#c6a864] text-xl"></i>
        </div>

        <p className="text-white/80 text-xs tracking-[0.4em] uppercase mb-3 font-light">
          Al Koudh 7, Mazoon Street, Muscat — Oman
        </p>
        <p className="text-white/60 text-xs mb-4 tracking-wide" style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}>
          الخوض 7، شارع مزون، مسقط — سلطنة عمان
        </p>

        <h1
          className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-wider mb-2"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Blue Moon
        </h1>
        <p
          className="text-white text-2xl sm:text-3xl font-light tracking-[0.15em] mb-3"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          <span className="italic">Beauty</span> Salon &amp; Spa
        </p>

        {/* Arabic name */}
        <p
          className="text-[#c6a864] text-2xl sm:text-3xl font-bold mb-2 tracking-wide"
          style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
        >
          صالون وسبا القمر الأزرق
        </p>
        <p
          className="text-white/70 text-base sm:text-lg mb-6"
          style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
        >
          صالون تجميل وسبا فاخر في مسقط، عمان
        </p>

        <p className="text-white/70 text-sm tracking-widest max-w-sm sm:max-w-md mb-3 font-light">
          Your sanctuary for beauty, wellness &amp; transformation in Muscat
        </p>
        <p
          className="text-white/60 text-sm mb-10 tracking-wide"
          style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
        >
          وجهتك الأولى للجمال والعناية والاسترخاء في الخوض، مسقط
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <a
            href="https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer bg-[#c6a864] text-white text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-[#b8965a] transition-colors duration-300 flex items-center gap-2"
          >
            <i className="ri-whatsapp-line text-base"></i>
            <span>Book via WhatsApp</span>
            <span className="opacity-80" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>/ احجزي الآن</span>
          </a>
          <a
            href="#services"
            className="whitespace-nowrap cursor-pointer border border-white text-white text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-white/10 transition-colors duration-300 flex items-center gap-2"
          >
            <span>Explore Services</span>
            <span className="opacity-70" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>/ خدماتنا</span>
          </a>
        </div>
      </div>

      {/* Slide dots */}
      <div className="absolute bottom-16 left-1/2 -translate-x-1/2 z-10 flex gap-2 items-center">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            onClick={() => {
              setPrev(current);
              setTransitioning(true);
              setCurrent(i);
              setTimeout(() => { setPrev(null); setTransitioning(false); }, 1200);
            }}
            className={`cursor-pointer transition-all duration-300 rounded-full ${
              i === current ? "w-6 h-1.5 bg-[#c6a864]" : "w-1.5 h-1.5 bg-white/40 hover:bg-white/70"
            }`}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-10 bg-white/40"></div>
        <i className="ri-arrow-down-line text-white/60 text-sm"></i>
      </div>
    </section>
  );
}
